import React from "react";
import EntitySerachReportTable from "../components/EntitySerachReport/EntitySerachReports";
import { NavLink, useSearchParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

const EntitySerachReports = () => {

	let [searchParams, setSearchParams] = useSearchParams();
	let search_id = searchParams.get("id")
	let new_report = searchParams.get("create")
	return (
		<Container style={{  "max-width": "1300px"}}>
			<EntitySerachReportTable search_id={search_id} new_report={new_report}/>
			<NavLink to={`/files?projectid=${search_id}`} activeStyle>
				{/* <Button variant="outline-primary">Select Search Type</Button>{' '} */}
			</NavLink>
			<br/>
				<Button variant="primary" style={{"margin-bottom":"10px"}} onClick={() => window.print()}>Print</Button>
		</Container>
		
	);
};

export default EntitySerachReports;